import { useState } from "react";

const defaultNavItems = [
  { href: "#reasons", label: "選ばれる理由" },
  { href: "#services", label: "サービス" },
  { href: "#pricing", label: "料金目安" },
  { href: "#flow", label: "作業の流れ" },
  { href: "#cases", label: "作業事例" },
  { href: "#voices", label: "お客様の声" },
  { href: "#faq", label: "よくある質問" },
  { href: "#company", label: "会社概要" },
];

export default function Header({
  linkPrefix = "",
  navItems = defaultNavItems,
}: {
  linkPrefix?: string;
  navItems?: { href: string; label: string }[];
}) {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background-50 border-b border-background-200">
      <div className="w-full px-4 md:px-6 lg:px-10 flex items-center justify-between h-16 md:h-[68px]">
        <a href={`${linkPrefix}#top`} className="flex items-center shrink-0 cursor-pointer mr-4">
          <span className="font-heading font-bold text-lg md:text-xl text-foreground-950 tracking-wide whitespace-nowrap">
            京都ゴミ処分センター
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-1 xl:gap-5">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={`${linkPrefix}${item.href}`}
              className="text-[13px] xl:text-sm font-medium text-foreground-600 hover:text-primary-600 whitespace-nowrap cursor-pointer px-2 py-1.5 transition-colors"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2 md:gap-4">
          <div className="hidden md:flex flex-col items-end leading-tight">
            <a
              href="tel:0120024747"
              className="flex items-center gap-1.5 font-heading font-bold text-sm md:text-base text-foreground-950 cursor-pointer hover:text-primary-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-phone-fill text-primary-500 text-base"></i>
              0120-02-4747
            </a>
            <span className="text-[10px] md:text-[11px] text-foreground-500 tracking-wide whitespace-nowrap">
              年中無休 9:00〜17:00
            </span>
          </div>

          <a
            href="https://line.me/ti/p/520wvids"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 px-3.5 md:px-5 py-2 md:py-2.5 rounded-md bg-accent-700 hover:bg-accent-800 text-background-50 font-bold text-xs md:text-sm whitespace-nowrap cursor-pointer transition-colors"
          >
            <i className="ri-line-fill text-base md:text-lg"></i>
            <span className="hidden sm:inline">LINE相談</span>
          </a>

          <a
            href="tel:0120024747"
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50 cursor-pointer"
            aria-label="電話"
          >
            <i className="ri-phone-fill text-lg"></i>
          </a>

          <button
            onClick={() => setOpen(!open)}
            aria-label="メニュー"
            className="lg:hidden w-9 h-9 flex items-center justify-center rounded-md text-foreground-700 hover:bg-background-100 cursor-pointer transition-colors"
          >
            <i className={`ri-${open ? "close" : "menu"}-line text-xl`}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-3 flex flex-col gap-0.5">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={`${linkPrefix}${item.href}`}
                onClick={() => setOpen(false)}
                className="py-3 px-2 text-sm text-foreground-700 hover:text-primary-600 border-b border-background-200 last:border-b-0 cursor-pointer transition-colors"
              >
                {item.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}